import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('user_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(r => r, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('user_token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

export const authApi = {
  register: (d: any) => api.post('/register', d),
  login: (d: any) => api.post('/login', d),
  logout: () => api.post('/logout'),
  me: () => api.get('/me'),
  forgotPassword: (d: any) => api.post('/forgot-password', d),
  resetPassword: (d: any) => api.post('/reset-password', d),
};

export const profileApi = {
  update: (d: any) => api.put('/profile', d),
};

export const metaApi = {
  getAuthUrl: () => api.get('/meta/auth-url'),
  getIgAuthUrl: () => api.get('/meta/ig-auth-url'),
  getPageSession: (sessionId: string) => api.get('/meta/page-session', { params: { session_id: sessionId } }),
  connectPage: (d: any) => api.post('/meta/connect-page', d),
  disconnect: () => api.post('/meta/disconnect'),
  status: () => api.get('/meta/status'),
};

export const subscriptionApi = {
  plans: () => api.get('/plans'),
  status: () => api.get('/subscription/status'),
  setupIntent: () => api.post('/subscription/setup-intent'),
  subscribe: (d: any) => api.post('/subscription/subscribe', d),
  changePlan: (d: any) => api.post('/subscription/change-plan', d),
  cancel: () => api.post('/subscription/cancel'),
  resume: () => api.post('/subscription/resume'),
  paymentMethod: () => api.get('/subscription/payment-method'),
  updatePaymentMethod: (d: any) => api.post('/subscription/payment-method', d),
  removePaymentMethod: () => api.delete('/subscription/payment-method'),
};

export const billingApi = {
  update: (d: any) => api.put('/profile/billing', d),
};

export const postsApi = {
  list: (page = 1) => api.get(`/posts?page=${page}`),
  create: (formData: FormData) => api.post('/posts', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  show: (id: number) => api.get(`/posts/${id}`),
};

export const resultsApi = {
  // Fetches posts with real-time Meta stats (cached 15 min server-side)
  get: () => api.get('/results'),
};

export default api;
